module.exports = __webpack_public_path__ + "static/img/img_cabinet.05ddbb68.png";